const STORAGE_BYTES_PER_UNIT = 100_000_000;
const EGRESS_BYTES_PER_UNIT = 100_000_000;

// A stale snapshot can deny work only from cumulative compute and egress;
// storage can fall between refreshes.
export const TINES_UNITS_STALE_MS = 15 * 60 * 1000;

export function startOfMonthUtc(at = Date.now()): number {
  const now = new Date(at);
  return Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), 1);
}

const COMPUTE_RATE_TIERS: { upTo: number; rate: number }[] = [
  { upTo: 100, rate: 1 },
  { upTo: 500, rate: 0.75 },
  { upTo: 1_000, rate: 0.5 },
  { upTo: 5_000, rate: 0.25 },
  { upTo: 10_000, rate: 0.1 },
  { upTo: 100_000, rate: 0.01 },
  { upTo: 1_000_000, rate: 0.005 },
  { upTo: Infinity, rate: 0.0025 },
];

export function computeUnitsForWorkflowSeconds(seconds: number): number {
  let units = 0;
  let tierFloor = 0;
  for (const { upTo, rate } of COMPUTE_RATE_TIERS) {
    if (seconds <= tierFloor) break;
    units += (Math.min(seconds, upTo) - tierFloor) * rate;
    tierFloor = upTo;
  }
  return units;
}

export function computeTinesUnits({
  storageBytes,
  egressBytes,
  computeSecondsByWorkflow,
}: {
  storageBytes: number;
  egressBytes: number;
  computeSecondsByWorkflow: number[];
}) {
  const compute = computeSecondsByWorkflow.reduce(
    (sum, seconds) => sum + computeUnitsForWorkflowSeconds(seconds),
    0
  );
  const storage = storageBytes / STORAGE_BYTES_PER_UNIT;
  const egress = egressBytes / EGRESS_BYTES_PER_UNIT;
  return { compute, storage, egress, total: compute + storage + egress };
}

export function formatTinesUnits(units: number): string {
  const rounded =
    units >= 100 ? Math.round(units) : Math.round(units * 10) / 10;
  return rounded.toLocaleString(undefined, { maximumFractionDigits: 1 });
}
